// A plain surface container — a Card without the header/footer structure.
// Use it for a section that groups content but has no titled chrome.
//
// tone="inset" carries --bg-inset, which is the code-block ground. Accent
// text must NEVER go inside it: --accent-on-light on --bg-inset fails AA.

import "./ui.css";
import type { ReactNode } from "react";

export type PanelProps = {
  tone?: "surface" | "inset";
  children: ReactNode;
};

export function Panel({ tone = "surface", children }: PanelProps) {
  return (
    <div className="maisight-ui-panel" data-tone={tone}>
      {children}
    </div>
  );
}
